import React, { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { AMBKingConfig } from '../../entities/AMBKing'
import ProviderList from './Betflix/ProviderList'
import { Button, Card, Carousel, Empty, Flex, Skeleton } from 'antd'
import { CategoryGameAMBKing1 } from '../../utils/categoryGame'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
import { useLocation, useHistory } from 'react-router-dom'
import MainSlider from '../Wallet/MainSlider'
import Footer from '../Layout/Footer'
import SeoContent from '../Layout/SeoContent'
import LoadingLayout from '../Layout/LoadingLayout'
import Popup from '../Popup'
import WalletPromotionContainer from '../Home/WalletPromotionContainer'
import CheckInModal from '../CheckIn/CheckInModal'
import GameList from './Betflix/GameList'
import { getImgGameTypeBetflix } from '../../utils/imgProviderBetFlix'
import LineLogin from '../../views/LineLogin';
import { makePath } from '../../helpers/path'

import JackpotWidget from '../Home/JackpotWidget';
import OnlineWidget from '../Home/OnlineWidget';
import WithdrawWidget from '../Home/WithdrawWidget';

const BetflixHome = () => {
    const location = useLocation()
    const history = useHistory()


    const [config, setConfig] = useState<AMBKingConfig | undefined>(undefined)
    const [provider, setProvider] = useState('')
    const [gameType, setGameType] = useState<string | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingAMBKing, setLoadingAMBKing] = useState<boolean>(false)
    const [allProvider, setAllProvider] = useState<any>(undefined)
    const [loadingProvider, setLoadingProvider] = useState<boolean>(false)

    const tabsRef = useRef<(HTMLDivElement | null)[]>([])
    const tabListRef = useRef<HTMLDivElement | null>(null)
    const [distanceFromMenuToTab, setDistanceFromMenuToTab] = useState<number>(0)
    const [widthToTab, setWidthToTab] = useState<number>(0)

    const providerState = useSelector((state: ApplicationState) => state.provider)
    const providerHomeState = useSelector((state: ApplicationState) => state.gamesHome)
    const prefixState = useSelector((state: ApplicationState) => state.prefix)
    const userState = useSelector((state: ApplicationState) => state.user)

    // 🔹 ข้อมูล prefix 
    const prefixData = [
        { prefix: 'ALD88', jackpot: 516_196, online: 8_231, online2: 8_000 },
        { prefix: 'WK89', jackpot: 716_196, online: 9_491, online2: 9_000 },
        { prefix: 'LK789', jackpot: 416_196, online: 5_294, online2: 5_000 },
        { prefix: 'LEXY88', jackpot: 616_196, online: 6_491, online2: 6_000 },
        { prefix: '1XHENG', jackpot: 586_196, online: 5_146, online2: 5_000 },
        { prefix: 'HRM888', jackpot: 886_196, online: 10_146, online2: 10_000 },
    ] as const;

    // 🔹 prefix ที่ต้องการให้แสดง (จะใช้ทั้งหมดก็ได้)
    const prefixShow = prefixData.map((p) => p.prefix);

    // 🔹 state ตัวอย่าง (มาจาก context/redux/form แล้วแต่โครงสร้างจริง)
    const { prefix } = prefixState.info ?? {};

    // 🔹 หา record ที่ตรงกับ prefix ปัจจุบัน
    const current = prefixData.find((p) => p.prefix === prefix);

    const [isSticky, setIsSticky] = useState<boolean>(false)

    const handleGameType = (game: string) => {
        const params = new URLSearchParams(location.search)

        window.scrollTo({ top: 0, behavior: 'smooth' })
        setProvider('')
        setGameType(game)
        params.set('gameType', game)
        history.push({ search: params.toString() })
    }

    const desiredOrder = ['สล็อต', 'คาสิโน', 'กีฬา', 'ปลา']

    const sortedTabs = providerHomeState?.info?.tabs.sort((a: any, b: any) => {
        return desiredOrder.indexOf(a.label) - desiredOrder.indexOf(b.label)
    })

    const TabGameType = loadingAMBKing && sortedTabs.filter((item: any) => item.enable === true).map((x: any, key: number) => {
        return (
            <div
                id={x.key}
                className={`launch-game-tab launch-game-tab-${x.game} ${x.game === gameType ? `launch-game-tab-active` : ''}`}
                key={`menu-tab-${x.game}`}
                onClick={() => { handleGameType(x.game) }}
            >
                <img src={`/icons/game-type/${x.game}.png`} alt={x.label} />
                <span>{x.label === 'ปลา' ? 'ยิงปลา' : x.label}</span>
            </div>
        )
    })

    useEffect(() => {
        const handleScroll = () => {
            if (tabListRef.current) {
                setIsSticky(tabListRef.current.getBoundingClientRect().top <= 48)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    useEffect(() => {
        if (providerHomeState?.info !== undefined) {
            const dataObject = Object.keys(providerHomeState?.info?.data)
                .map(key => ({ key, value: providerHomeState?.info?.data[key] }))
                .sort((a, b) => a.value.order - b.value.order)
                .reduce((acc: any, { key, value }) => {
                    acc[key] = value
                    return acc
                }, {})

            setConfig(providerHomeState?.info)
            setAllProvider(dataObject)

            if (Object.values(providerHomeState?.info?.data).length === 1) {
                setGameType(Object.keys(providerHomeState?.info?.data)[0])
            }

            // setGameType(providerHomeState?.info.tabs.filter((item: any) => item.enable === true)[0].game)
            setLoadingAMBKing(true)
        }
    }, [providerState?.info, providerHomeState?.info, location]) // eslint-disable-line

    useEffect(() => {
        if (!provider) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }, [provider])

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const gameTypeQuery = params.get('gameType')

        if (gameTypeQuery) {
            setGameType(gameTypeQuery)
        } else {
            setGameType('slot')
            params.set('gameType', 'slot')
            history.push({ search: params.toString() })
        }

        setLoading(false)
    }, [location.search])

    useLayoutEffect(() => {
        const observer = new MutationObserver(() => {
            if (tabListRef.current) {
                const activeTab = Array.from(tabListRef.current?.querySelector('.launch-game-tabs-menu')?.children || []).find((tab: Element) => tab.classList.contains("launch-game-tab-active"))

                if (activeTab) {
                    const tabsParent = tabListRef.current.querySelector('.launch-game-tabs-menu')
                    const distance = tabsParent && activeTab ? activeTab.querySelectorAll('span')[0]?.getBoundingClientRect().left - tabsParent.getBoundingClientRect().left : 0

                    setDistanceFromMenuToTab(distance)
                    setWidthToTab(activeTab.querySelectorAll('span')[0]?.getBoundingClientRect().width || 0)
                }

                observer.disconnect()
            }
        })

        if (tabListRef.current) {
            const activeTab = Array.from(tabListRef.current?.querySelector('.launch-game-tabs-menu')?.children || []).find((tab: Element) => tab.classList.contains("launch-game-tab-active"))

            if (activeTab) {
                const tabsParent = tabListRef.current?.querySelector('.launch-game-tabs-menu')
                const distance = activeTab && tabsParent ? activeTab.querySelectorAll('span')[0]?.getBoundingClientRect().left - tabsParent.getBoundingClientRect().left : 0

                setDistanceFromMenuToTab(distance)
                setWidthToTab(activeTab.querySelectorAll('span')[0]?.getBoundingClientRect().width || 0)
            }
        } else {
            observer.observe(document.body, { childList: true, subtree: true })
        }

        return () => {
            observer.disconnect()
        }
    }, [gameType])

    if (!config) {
        return (
            <div>
                <div className='ambbet-topbar-skeleton'>
                    <div className='amb-button-skeleton'>
                        {
                            Array.from({ length: 10 }, (_, index) => (
                                <Skeleton.Button key={index} active />
                            ))
                        }
                    </div>
                </div>

                <div className='ambbet-provider-skeleton'>
                    {
                        Array.from({ length: 24 }, (_, index) => (
                            <Skeleton.Button key={index} active />
                        ))
                    }
                </div>
            </div>
        )
    }

    return (
        <div className='launch-game-container'>
            <MainSlider prefixState={prefixState} />

            {/* {!userState.info && current && prefixShow.includes(current.prefix) && (
                <>
                    <OnlineWidget data={current.online} data2={current.online2} />
                    <JackpotWidget data={current.jackpot} />
                    <WithdrawWidget />
                </>
            )} */}

            {!userState.info && (
                <div className="topbar-member-betflix">
                    <Button
                        type='primary'
                        size='small'
                        style={{ display: 'block', fontSize: 14 }}
                        block
                        onClick={() => history.push(makePath('/login'))}
                    >
                        เข้าสู่ระบบ
                    </Button>
                    {(!prefixState.info?.functions.hasOwnProperty("offRegister") || !prefixState.info?.functions['offRegister']) && (
                        <Button
                            size='small'
                            style={{ marginLeft: 12, display: 'block', fontSize: 14 }}
                            block
                            onClick={() => history.push(makePath('/register'))}
                        >
                            สมัครสมาชิก
                        </Button>
                    )}
                </div>
            )}
            <div className='launch-game-tabs'>
                {sortedTabs.filter((item: any) => item.enable === true).length > 1 && (
                    <div ref={tabListRef} className={`launch-game-tabs-list ${isSticky ? 'launch-game-tabs-list-sticky' : ''}`}>
                        <div className='launch-game-tabs-menu'>
                            {TabGameType}
                        </div>
                        <div className='launch-game-tabs-underline' style={{ width: widthToTab, transform: `translateX(${distanceFromMenuToTab}px)` }}></div>
                    </div>
                )}

                <div className='launch-game-tab-content'>
                    {loading ? (
                        <LoadingLayout prefix={prefixState} />
                    ) : (
                        !provider ? (
                            (allProvider !== undefined ? (
                                <ProviderList
                                    key={`ProviderList_${gameType}_${gameType}`}
                                    config={allProvider}
                                    type={gameType as string}
                                    setProvider={setProvider}
                                    setGameType={setGameType}
                                />
                            ) :
                                <div style={{ display: 'flex', width: '100%', marginTop: '12px' }}>
                                    <Empty
                                        description='ไม่พบเกมส์'
                                        image='/icons/new/empty-box.svg'
                                        imageStyle={{ height: 88 }}
                                        style={{ flex: 'auto', marginTop: 24 }}
                                    />
                                </div>
                            )
                        ) : (
                            <GameList
                                games={allProvider[provider]}
                                allprovider={allProvider}
                                provider={provider as string}
                                gameType={gameType as string}
                                loadingProvider={loadingProvider}
                                setProvider={setProvider}
                                setLoadingProvider={setLoadingProvider}
                                setLoading={setLoading}
                                pathName={location.pathname}
                            />
                        )
                    )}
                </div>
            </div>

            {/* Popup */}
            <Popup />

            {/* CheckIn */}
            {prefixState.info?.checkin.enable && !prefixState.info?.checkin.pupupStartDisable && <CheckInModal />}

        </div>
    )
}

export default BetflixHome
